
export default {
  components: {
    hotSolutionsSection: () => import('~/components/Organisms/Solutions/SolutionsSection/SolutionsSection.vue'),
    OrganicModal: () => import('~/components/Molecules/Organic/Modal/Modal.vue'),
    hotAnchorList: () => import('~/components/Molecules/AnchorList/AnchorList.vue'),
    hotSolutionsFormats: () => import('~/components/Organisms/Solutions/SolutionsFormats/SolutionsFormats.vue'),
    hotEmbedSso: () => import('~/components/Molecules/EmbedSso/EmbedSso.vue'),
    hotSolutionsFeatures: () => import('~/components/Organisms/Solutions/SolutionsFeatures/SolutionsFeatures.vue'),
    hotSolutionsPayments: () => import('~/components/Organisms/Solutions/SolutionsPayments/SolutionsPayments.vue'),
    hotSolutionsDistribution: () =>
      import('~/components/Organisms/Solutions/SolutionsDistribution/SolutionsDistribution.vue'),
    hotSolutionsProductsPage: () =>
      import('~/components/Organisms/Solutions/SolutionsProductsPage/SolutionsProductsPage.vue'),
    hotSolutionsResults: () => import('~/components/Organisms/Solutions/SolutionsResults/SolutionsResults.vue'),
    hotSolutionsTeam: () => import('~/components/Organisms/Solutions/SolutionsTeam/SolutionsTeam.vue'),
  },

  computed: {
    isPortuguese() {
      return Boolean(['pt-br'].includes(this.$i18n.locale))
    },
  },
}
